import { ZUid } from "src/types/zUid";

export const makeId = (prevId: ZUid, key: string): string => `${prevId}.${key}`;
